import React, { Fragment, useEffect, useRef } from "react"
import { FaTimes } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Input } from "components"
import classes from "./CmChipInput.module.scss"

const CmChipInput = (props) => {
  const {
    error,
    disabled,
    inputRef,
    couponCodes,
    inputText,
    setInputText,
    onDeleteCoupon,
    handleAddCoupon,
  } = props

  const [t, i18n] = useTranslation()

  const textRef = useRef(null)

  const handleChangeText = async (e) => {
    const value = e.target.value

    setInputText(value.trim())
  }

  const handleFocus = () => {
    inputRef.current.focus()
  }

  useEffect(() => {
    inputRef.current.style.width =
      inputText !== "" ?
        `${textRef.current.offsetWidth}px` : "5px"
  }, [inputText])

  const showPlaceholder =
    !inputText && couponCodes.length === 0

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <label className={classes["label"]}>
        {t("کوپن_ها")}
      </label>

      <div
        onClick={() => !disabled && handleFocus()}
        className={clsx(
          classes["container"],
          !!error && classes["container-error"],
          couponCodes.length > 0 && classes["remove-padding"]
        )}
      >
        <div className={classes["chip-container"]}>
          {couponCodes.map((coupon) => (
            <div
              key={coupon}
              className={clsx(
                classes["chip"],
                isLtr && classes["chip-ltr"]
              )}
            >
              <div className={classes["chip-text"]}>
                {coupon}
              </div>

              {
                !disabled &&
                <div
                  onClick={() => onDeleteCoupon(coupon)}
                  className={clsx(
                    classes["remove-chip"],
                    isLtr && classes["remove-chip-ltr"]
                  )}
                >
                  <FaTimes size={12} />
                </div>
              }
            </div>
          ))}

          <div
            ref={textRef}
            disabled={disabled}
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {inputText}
          </div>

          <form
            onSubmit={(e) => !disabled && handleAddCoupon(e)}
          >
            <Input
              ref={inputRef}
              value={inputText}
              disabled={disabled}
              onChange={(e) => handleChangeText(e)}
              className={clsx(
                classes["input"],
                couponCodes.length > 0 && classes["add-margin"]
              )}
            />
          </form>
        </div>

        {
          !!showPlaceholder &&
          <div
            className={clsx(
              classes["placeholder"],
              isLtr && classes["placeholder-ltr"]
            )}
          >
            {t("کد_کوپن_را_وارد_کنید")}
          </div>
        }
      </div>

      {!!error && <div className={classes["error"]}>{error}</div>}
    </Fragment>
  )
}

export default CmChipInput
